import React from "react";

export default function blankTemplate({ children }) {
  return <div className="w-100 h-100">{children}</div>;
}
